import MarqueeLib from "react-fast-marquee";
import { Diamond } from "lucide-react";

const ITEMS = [
  "Fractional CMO expertise. Full-time growth results.",
  "Strategy before spend.",
  "Clarity first. Then scale.",
  "CMO-level leadership, without the overhead.",
];

const Marquee = () => (
  <div data-testid="editorial-marquee" className="border-y border-line py-5 md:py-7 overflow-hidden">
    <MarqueeLib speed={35} gradient={false} pauseOnHover>
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic text-2xl md:text-4xl font-light text-ink px-8 whitespace-nowrap">
            {item}
          </span>
          <Diamond size={10} className="text-taupe fill-taupe shrink-0" />
        </span>
      ))}
    </MarqueeLib>
  </div>
);

export default Marquee;
